export default __webpack_public_path__ + "static/media/me3_white_Xicon.1780a912.svg";